module.exports = __webpack_public_path__ + "static/img/i-a-o-right2.c43a6c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i-a-o-right2.jpg
// module id = EweJ
// module chunks = 5